import { all, takeEvery, put, fork } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';

import { getToken, clearToken } from '../../library/helpers/utility';
import cookieHelper from '../../library/helpers/cookieHelper';
import actions from './actions';

import { invalidateCurrentUserPermissionsCache } from '../../../common/apis/permissions-api-new';
import { invalidateStatusCountsCache } from '../../../Sleep/apis/status-counts';
import { clearInFlightRequests } from '../../library/helpers/apiHelper';

const history = createBrowserHistory();
const fakeApiCall = true; // auth0 or express JWT

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function* ({ payload }) {
    const { token } = payload;
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
        profile: 'Profile',
      });
    } else {
      if (fakeApiCall) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: 'secret token',
          profile: 'Profile',
        });
      } else {
        yield put({ type: actions.LOGIN_ERROR });
      }
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield cookieHelper.setToken(payload.token);
    // yield localStorage.setItem('id_token', payload.token);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () { });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    yield cookieHelper.clearToken();
    yield clearToken();

    // Clear all user-scoped session keys so state cannot leak across users.
    cookieHelper.clearUserDetails();
    localStorage.removeItem('@token');
    localStorage.removeItem('@refreshToken');
    localStorage.removeItem('userServiceAccess');
    localStorage.removeItem('redirectPath');
    localStorage.removeItem('last_activity_timestamp');
    localStorage.removeItem('token_expiry_timestamp');
    localStorage.removeItem('@JivaHealthCaresAppDashbordLayout');
    localStorage.removeItem('id_token');
    localStorage.removeItem('FCMToken');
    localStorage.removeItem('user_role');
    localStorage.removeItem('role');
    sessionStorage.removeItem('session_timeout_reason');

    // Invalidate in-memory caches and pending network requests
    try {
      invalidateCurrentUserPermissionsCache();
    } catch (e) {}
    try {
      invalidateStatusCountsCache();
    } catch (e) {}
    try {
      clearInFlightRequests();
    } catch (e) {}

    // Clear persistent conversation cache on logout
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('conv_') || key.startsWith('chatSession_')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {}

    // Broadcast logout and reset to all mounted context providers & UI components
    if (typeof window !== 'undefined') {
      try {
        window.dispatchEvent(new CustomEvent('userLoggedOut'));
      } catch (e) {}
    }

    history.push('/');
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const token = getToken().get('idToken');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: 'Profile',
      });
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}
